export default function moneyFormat( value: string | number, split = false ): string {
  const parsedValue = typeof value === "number" ? value : parseFloat(value)
  const newNumber = split ? parsedValue / 100 : parsedValue;

  return new Intl.NumberFormat('en-US', {
      style: 'currency',
      currency: 'USD',
    }).format(newNumber);
}